import React from "react"
import ReactDOM from "react-dom"
import TeaserMessageCard from "./teaser-message-card"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export default class TeaserMessageCardModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.blockJson = elem.dataset.blockJson && JSON.parse(elem.dataset.blockJson)
    self.init()
    return self
  }

  init() {
    const self = this
    const icon = SelectionFactoryHelper.getFromSelectionFactory(self.blockJson.icon)

    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<TeaserMessageCard {...self.blockJson} link={self.blockJson.teaserCardLink} icon={icon} />, self.elem)
  }
}
